var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{staticClass:"responsive-bar",scopedSlots:_vm._u([{key:"title",fn:function(){return undefined},proxy:true}])}),_c('div',{staticClass:"knet-payment-page"},[_c('div',{staticClass:"payment-message"},[_vm._v(" "+_vm._s(_vm.$t("payment-transaction-is-processed"))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }